module.exports = __webpack_public_path__ + "static/img/studiesThree.80bbc96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/studiesThree.png
// module id = QdNd
// module chunks = 1